module.exports = function(options, callback) {
    this.__fetchCB = callback;
    this._sendMessage('fetchRequest', options);
};
